import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FiCheck, FiChevronDown } from "react-icons/fi";

import Text from "./Text";

const ComboBox = ({
  onChange = null,
  options: aData = [],
  label: sLabel = null,
  selected: oSelected = null,
  disabled: bDisabled = false,
  className: sClassName = null,
  containerClassName: sContainerClassName = null,
  labelClass: sCustomLabelClass = null,
  buttonClassName: sCustomButtonClass = null,
  emptyLabel: sEmptySelectionLabel = "Seleccione una opción",
}) => {
  // Rediseño: el botón usa el estilo común de campos (index.css); la lista, bordes finos y sombra suave
  const sButtonClass = "ui-field relative w-full cursor-pointer pl-3 pr-9 text-left";
  const sOptionContainerClass = "absolute z-50 w-full mt-1 max-h-60 overflow-auto rounded-md bg-white dark:bg-gray-800 border border-line dark:border-line-dark p-1 text-sm shadow-md focus:outline-none";
  const sOptionClass = "relative cursor-pointer select-none rounded py-1.5 pl-8 pr-3";
  const sOptionActiveClass = "bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100";
  const sOptionInactiveClass = "text-gray-700 dark:text-gray-300";

  const sLabelClassName = "text-ellipsis whitespace-nowrap overflow-hidden " + sCustomLabelClass || "";

  return (
    <div className={sContainerClassName || null}>
      {sLabel && (
        <Text className={sLabelClassName} size={"text-sm"}>
          {sLabel}
        </Text>
      )}
      <Listbox value={oSelected || null} onChange={oItem => onChange && onChange(oItem)} disabled={bDisabled}>
        <div className={`relative ${sLabel ? "mt-1" : ""} ` + sClassName}>
          <Listbox.Button className={sCustomButtonClass || sButtonClass}>
            <span className={`block truncate text-sm ${oSelected?.label ? "text-gray-800 dark:text-white" : "text-gray-400 dark:text-gray-500"}`}>
              {oSelected?.label || sEmptySelectionLabel}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2.5">
              <FiChevronDown className="h-4 w-4 text-gray-400" />
            </span>
          </Listbox.Button>
          <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
            <Listbox.Options className={sOptionContainerClass}>
              {aData.map((oItem, nIndex) => (
                <Listbox.Option
                  key={nIndex}
                  value={oItem}
                  className={({ active: bActive }) =>
                    sOptionClass + " " + (bActive ? sOptionActiveClass : sOptionInactiveClass)
                  }
                >
                  {({ selected: oSelectedItem }) => (
                    <>
                      <span className={`block truncate ${oSelectedItem ? "font-medium" : "font-normal"}`}>
                        {oItem.label}
                      </span>
                      {oSelectedItem ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-2.5">
                          <FiCheck className="h-4 w-4 text-primary-500" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default ComboBox;
